// extracted by mini-css-extract-plugin
export default {"logo":"index_logo_ffcUO","ad_1":"index_ad_1_Ypy3p","ad_2":"index_ad_2_YaTaH","logoText":"index_logoText_vMXh1"};